var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { HomePageWidgetTypes } from "@irati/types";
import convertVideoUrlToEmbedUrl from "@irati/homepage/helpers/convertVideoUrlToEmbedUrl";
import { Tile, HoverOverlay } from "../styled/styled";
import EditWidget from "../EditWidget";
import MoveWidget from "../MoveWidget";
var Video = /** @class */ (function (_super) {
    __extends(Video, _super);
    function Video() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Video.prototype.render = function () {
        var _a = this.props, bgColor = _a.bgColor, color = _a.color, editTile = _a.editTile, hoverActive = _a.hoverActive, isOnDrag = _a.isOnDrag, removeTileFromGrid = _a.removeTileFromGrid, videoUrl = _a.videoUrl, widgetId = _a.widgetId;
        var videoOutput = convertVideoUrlToEmbedUrl(videoUrl);
        return (React.createElement(Tile, { bgColor: bgColor, color: color, hoverActive: hoverActive, noPadding: true, onDragActive: isOnDrag && hoverActive },
            React.createElement("iframe", { src: videoOutput.url, frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, title: "video", style: {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                } }),
            hoverActive &&
                React.createElement(React.Fragment, null,
                    React.createElement(EditWidget, { widgetId: widgetId, type: HomePageWidgetTypes.Video, bgColor: bgColor, color: color, removeTileFromGrid: removeTileFromGrid, videoUrl: videoUrl, editTile: editTile }),
                    React.createElement(MoveWidget, { smSquare: false }),
                    React.createElement(HoverOverlay, null))));
    };
    return Video;
}(PureComponent));
export default Video;
